// PasswordRecovery.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import styles from './Login&Register.module.css';

import { API_BASE_URL } from './Common';
import { ReactComponent as LoginIcon } from '../icons/login.svg';
import { ReactComponent as ProchildIcon } from '../icons/prochild.svg';
import { ReactComponent as KeyIcon } from '../icons/key.svg';
import { ReactComponent as EnvelopeIcon } from '../icons/envelope.svg';
const recoveryURL = `${API_BASE_URL}/password-recovery`;

function PasswordRecovery() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isEmailSent, setIsEmailSent] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post(recoveryURL, { email });
      // Assuming the response contains a success message upon successful password recovery
      setSuccessMessage(response.data.message);
      setIsEmailSent(true);
    } catch (error) {
      setError(error.response.data.message);
    }
  };

  return (
    <div className={styles.recoveryContainer}>

      <LoginIcon className={styles.loginIcon2}/>

      {isEmailSent ? <EnvelopeIcon className={styles.keyIcon}/> : <KeyIcon className={styles.keyIcon}/>}

      <div className={styles.bigText2}>
      {isEmailSent ? 'Verifique a sua caixa de e-mail!' : 'Esqueceu-se da password?'}
      </div>

      <div className={styles.welcomeText2}>
      {isEmailSent ? (
  <>
    Enviámos um link para redefinir a sua password.
    <br />
    Verifique a caixa de e-mail {email}
  </>
) : 'Sem problema!'}

      </div>
 {!isEmailSent && (
   <>
        <form onSubmit={handleSubmit} className={styles.recoveryForm}>

          <div className={styles.formGroup}>
            <label>E-mail</label>
            <input
            placeholder="Inserir e-mail"
            type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>

          {error && <p className={styles.errorMessage}>{error}</p>}
          {successMessage && <p className={styles.successMessage}>{successMessage}</p>}
          <button type="submit" className={styles.loginBtn}>Redefinir password</button>
        </form>

          <Link to="/" className={styles.myLinks}>Login?</Link>
          </>
)}

{isEmailSent && (
  <div className={styles.recoveryForm2}>
        <button
          className={styles.loginBtn}
        onClick={() => window.location.href = `mailto:`}
        >
          Abrir
        </button>
        <span className={styles.welcomeText2}>
  Não recebeu o e-mail? Clique
</span>&nbsp;
        <span
            className={styles.myLinks}
            onClick={handleSubmit}
          >
            aqui
          </span>
      </div>
      )}

        <ProchildIcon className={styles.loginIcon3}/>
    </div>
  );
}

export default PasswordRecovery;

